<template>
    <v-card :flat="flat">
        <v-card-text :class="{ 'px-2': $vuetify.breakpoint.xsOnly }">
            <v-layout row wrap>
                <v-flex :class="{ 'xs4 md2': !floating, xs4: floating }">
                    <v-img
                        v-if="item.product && productImage"
                        :src="productImage.small"
                        :lazy-src="productImage.placeholder"
                        :alt="productImage.image_description"
                        :aspect-ratio="1 / 1"
                    />
                </v-flex>

                <v-flex :class="{ 'xs8 md10': !floating, xs8: floating }">
                    <v-layout row wrap>
                        <v-flex :class="{ 'xs8 md12': !floating, xs8: floating }">
                            <router-link
                                :to="
                                    $product.getProductRouteConfig(
                                        item.product_id === item.catalog_item_id
                                            ? item.product
                                            : { id: item.catalog_item_id },
                                    )
                                "
                                class="subheading"
                                v-if="$basket.isNotBuyableItem(item) === false"
                            >
                                {{ $basket.getItemTitle(item) }}
                            </router-link>

                            <template v-else>
                                <span class="subheading">{{ $basket.getItemTitle(item) }}</span>
                            </template>

                            <div v-html="description"></div>
                        </v-flex>

                        <v-flex
                            v-if="!noControls"
                            :class="{ 'xs4 hidden-md-and-up text-xs-right': !floating, 'xs4 text-xs-right': floating }"
                        >
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on" @click="$basket.removeBasketItem(item)" class="ma-0">
                                        <v-icon color="grey lighten-1">delete</v-icon>
                                    </v-btn>
                                </template>

                                <span>{{ 'Remove product' | translation }}</span>
                            </v-tooltip>
                        </v-flex>

                        <v-flex xs12 v-if="!noControls && item.buyOptions && item.buyOptions.length">
                            <div class="caption" v-for="buyOption in item.buyOptions" :key="buyOption.name">
                                {{ getBuyOptionValuesString(buyOption.Values) }}
                            </div>
                        </v-flex>

                        <v-flex xs12 :style="{ 'margin-top': tierPriceHeight + 'px' }">
                            <v-layout class="pa-0 ma-0" row wrap align-center>
                                <v-flex
                                    v-if="!noControls"
                                    class="pa-0"
                                    :class="{ 'md4 hidden-sm-and-down': !floating, 'd-none': floating }"
                                >
                                    <a
                                        href="#"
                                        @click.prevent="$basket.removeBasketItem(item)"
                                        class="text-decoration-none remove-product-button"
                                    >
                                        <v-icon class="grey--text text--lighten-1 remove-item-icon">delete</v-icon>
                                        <span
                                            class="grey--text text--lighten-1 caption font-weight-bold text-uppercase"
                                        >
                                            {{ 'Remove product' | translation }}
                                        </span>
                                    </a>
                                </v-flex>

                                <v-flex
                                    :class="{
                                        grow: $vuetify.breakpoint.mdAndUp,
                                        shrink: $vuetify.breakpoint.smAndDown,
                                    }"
                                    v-if="!noControls && $basket.isNotBuyableItem(item) === false"
                                    class="text-xs-right"
                                >
                                    <amount-input
                                        v-show="!$basket.isCoupon(item.product)"
                                        :class="{ 'd-inline-block': !$basket.isCoupon(item.product) }"
                                        :value.sync="itemQuantity"
                                        :product="item.product"
                                        :current-merchant-id="item.options.merchant"
                                        :current-product-id="item.catalog_item_id"
                                        :key="`${item.catalog_item_id}-${item.options.merchant}`"
                                        is-basket-field
                                        tier-price-position="top"
                                        tier-price-alignment="center"
                                        tier-price-absolute
                                        :tier-price-height.sync="tierPriceHeight"
                                    />
                                </v-flex>

                                <v-flex grow v-else>
                                    <span>{{ 'number' | translation }} </span>
                                    {{ itemQuantity }}
                                </v-flex>

                                <v-flex
                                    class="text-xs-right font-weight-bold pr-0"
                                    :class="{
                                        shrink: $vuetify.breakpoint.mdAndUp,
                                        grow: $vuetify.breakpoint.smAndDown,
                                    }"
                                >
                                    <div>
                                        <span class="font-weight-bold">{{ 'price' | translation }} </span>

                                        <del v-if="isPriceWithDiscount(item)" class="org-preis">
                                            <span>{{
                                                $basket.getPriceData(item).original_price_inkl_vat | currency
                                            }}</span>
                                        </del>

                                        <span class="font-weight-bold">
                                            {{ itemPrice | currency }}
                                        </span>

                                        <br />

                                        <span v-if="isPriceWithDiscount(item)" class="success--text">
                                            {{ 'saving' | translation }}
                                            <span>
                                                {{
                                                    ($basket.getPriceData(item).original_price_inkl_vat -
                                                        $basket.getPriceData(item).price)
                                                        | currency
                                                }}
                                            </span>
                                        </span>
                                    </div>

                                    <span>{{ 'total' | translation }} </span>
                                    <span>{{ $basket.getBasketItemTotalPrice(item) | currency }}</span>
                                </v-flex>
                            </v-layout>
                        </v-flex>

                        <v-flex v-if="!noControls && selfPickup" xs12>
                            <v-checkbox
                                :disabled="!$basket.isItemPickupable(item, merchantId)"
                                hide-details
                                v-model="item.pickup"
                                @change="setItemPickup(item)"
                                label="Artikel selbst abholen"
                                class="justify-end"
                            />
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>

<style scoped lang="stylus">
.remove-product-button {
    * {
        vertical-align: middle;
    }
}
.remove-item-icon {
    width: 17px;
}
</style>

<script>
import AmountInput from '@breakmedia/prime-vue-product/src/product-page/AmountInput';
import { mapGetters } from 'vuex';

export default {
    name: 'BasketItem',
    components: {
        AmountInput,
    },
    data() {
        return {
            itemQuantity: 1,
            tierPriceHeight: 0,
        };
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
        floating: {
            type: Boolean,
            default: false,
        },
        noControls: {
            type: Boolean,
            default: false,
        },
        selfPickup: {
            type: Boolean,
            default: false,
        },
        hideTierPriceInfo: {
            type: Boolean,
            default: false,
        },
        quantity: {
            type: Number,
        },
        flat: Boolean,
    },
    created() {
        if (!this.item.hasOwnProperty('product')) {
            this.item.product = this.$basket.getBasketItemProduct(this.item);
        }
    },
    computed: {
        ...mapGetters('Product', ['getProductAttributeByLanguage']),
        itemPrice() {
            const { product } = this.item;
            if (this.$basket.isCoupon(product)) {
                return this.$basket.getBasketItemTotalPrice(this.item);
            }
            return this.$basket.getPriceData(this.item).price;
        },
        productImage() {
            let image;

            if (this.item.catalog_item_id !== this.item.product_id && this.item.product.images.product_images.length) {
                for (let productImage of this.item.product.images.product_images) {
                    if (productImage.products && productImage.products.includes(this.item.catalog_item_id)) {
                        image = productImage;
                        break;
                    }
                }
            }

            if (!image) {
                image = this.item.product.images.default;
            }

            return image;
        },
        description() {
            return this.getProductAttributeByLanguage(this.item.product, 'product.description.short');
        },
    },
    methods: {
        getBuyOptionValuesString(buyOptionValues) {
            let result = [];

            for (let value of Object.values(buyOptionValues)) {
                if (value.value) {
                    result.push(this.$language.translate(value.name) + ': ' + this.$language.translate(value.value));
                }
            }

            return result.join(', ');
        },
        isPriceWithDiscount(item) {
            const priceData = this.$basket.getPriceData(item);
            if (priceData) {
                return priceData.original_price_inkl_vat > priceData.price;
            }
        },
    },
    watch: {
        itemQuantity(val) {
            if (this.item.quantity !== val) {
                this.item.quantity = val;
                this.$basket.updateBasketItem(this.item);
            }
        },
        quantity: {
            immediate: true,
            handler(val) {
                this.itemQuantity = val;
            },
        },
    },
};
</script>
